// Central place to define year -> tagId mapping
// Edit this file to add/remove years or change tag ids

export const YEAR_TO_TAG_ID = {
    2015: '2015public',
    2016: '2016Public', // note the capital P
    2017: '2017public',
    2018: 'public',     // 2018 is special in your codebase
    2019: '2019public',
    2020: '2020public',
    2021: '2021public',
    2022: '2022public',
    2023: '2023public',
    2024: '2024public',
    2025: '2025public',
    2026: '2026public',
};

export const YEARS = Object.keys(YEAR_TO_TAG_ID).map((y) => Number(y)).sort((a, b) => a - b);

